export const NAV_OFFSET = 65; // Height of the fixed header in pixels

export const SOCIAL_MEDIA_LINKS = {
    whatsapp: "https://wa.me/14796405446",
    youtube: "https://youtube.com/@vianphotography",
    pexels: "https://www.pexels.com/@vian-photography-1491190549/highlights/",
    facebook: "https://www.facebook.com/people/ViAn-Photography-NWA/61562148027535",
    instagram: "https://www.instagram.com/vianphotography27"
};

// Base URL for fetching repository config files via GitHub API
export const CONFIG_BASE_URL =
    'https://api.github.com/repos/vianphoto27/vian-photography-public/contents/config';
